import { render, staticRenderFns } from "./AddOrderPackages.vue?vue&type=template&id=698231f2"
import script from "./AddOrderPackages.vue?vue&type=script&lang=js"
export * from "./AddOrderPackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports